import EfFootNotes from '@elem/ui/ef-foot-notes';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('theProduct.FootTC');

    const { locale } = useRouter();
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);

    const configs = {
        text: 'text',
        langKey: 'theProduct.FootTC',
        // links: IS_EU_SITES ? [t('Q_a1'), t('Q_a2'), t('Q_a3'), t('Q_a4'), t('Q_a5'), t('Q_a6'), t('Q_a7'), t('Q_a8'), t('Q_a9')] : [t('Q_a1'), t('Q_a2')],
        // emails: [t('Q_mail1')],
    };

    return (
        <div className={styles.TheComp}>
            <EfFootNotes {...configs} />
        </div>
    );
}
